<script setup>
defineProps({ size: { type: Number, default: 32 }, title: { type: String, default: 'Catolica' } })
</script>

<template>
  <!-- Catolica brand mark (self-contained background, safe on light and dark surfaces) -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    :width="size"
    :height="size"
    role="img"
    :aria-label="title"
    class="shrink-0 rounded-[25%] dark:ring-1 dark:ring-white/10"
  >
    <title>{{ title }}</title>
    <rect width="64" height="64" rx="16" fill="#3730A3"/><path d="M46.5 20 A18 18 0 1 0 46.5 44" fill="none" stroke="#fff" stroke-width="5.5" stroke-linecap="round"/><path d="M33 20 V44 M25.5 28 H40.5" stroke="#F5C451" stroke-width="5" stroke-linecap="round"/>
  </svg>
</template>
